import { fireEvent, render, screen, within } from '@testing-library/react'

import Friends from './Friends'

describe('Friends screen', () => {
  test('renders the updated friend options and embedded forms', () => {
    render(<Friends />)

    expect(
      screen.getByRole('region', {
        name: /quieres apoyar nuestra asociación/i
      })
    ).toBeTruthy()

    expect(screen.getByRole('region', { name: /modalidades de amigas/i })).toBeTruthy()

    const formButtons = screen.getAllByRole('button', { name: /abrir formulario/i })
    expect(formButtons).toHaveLength(3)
    expect(screen.queryByTitle(/formulario de/i)).toBeNull()
    fireEvent.click(formButtons[0])
    expect(screen.getByTitle('Formulario de Amiga donadora')).toBeTruthy()
    expect(screen.getByText(/la aportación anual para 2026-2027 es de 26/i)).toBeTruthy()
    const collaboratorOverview = screen.getAllByRole('group')[0]
    expect(collaboratorOverview).toHaveProperty('open', false)
    const collaboratorArticle = screen.getByRole('article', { name: 'Amiga colaboradora' })
    expect(within(collaboratorArticle).getByText('Todo lo que necesitas saber')).toBeTruthy()
    expect(
      within(collaboratorArticle).getByRole('button', { name: 'Abrir formulario de Amiga colaboradora' })
    ).toBeTruthy()
    fireEvent.click(screen.getByText('Todo lo que necesitas saber'))
    expect(collaboratorOverview).toHaveProperty('open', true)
    expect(screen.getByText('Por qué hacerte Amiga colaboradora')).toBeTruthy()
    expect(screen.getByText('Compromisos de la Amiga colaboradora')).toBeTruthy()
  })
})
